module.exports = __webpack_public_path__ + "media/assets/images/app_store_sm-eng-fa325d175624f50134a87507a458e975.png";